import React from "react";
import Card from "../../widgets/Card/Card";

import styles from "./OrderDetails.module.scss";

const OrderPackagesDetails = ({ packages }) => {
  return (
    <div className={styles.sectionBlock}>
      <h3 className={styles.sectionTitle}>Order details</h3>
      <Card>
        {packages.length > 0 ? (
          packages.map((pkg, index) => (
            <div className={styles.packageItem} key={`${pkg}-${index}`}>
              {pkg}
            </div>
          ))
        ) : (
          <div className={styles.packageItem}>No packages available</div>
        )}
      </Card>
    </div>
  );
};

export default OrderPackagesDetails;
